export default __webpack_public_path__ + "static/media/btm_arrw_wins.23b86a02.svg";